import { base_url } from "services/routeScopeUtils"

export const SESSION = `${import.meta.env.VITE_API_BASE_URL}/v1/session`

export const NEW_SESSION = `${base_url()}/session`

export const USER_REGISTRATION_BASE = `${import.meta.env.VITE_API_BASE_URL}/professional-registration`
export const USER_REGISTRATION_BASE_V2 = `${import.meta.env.VITE_API_BASE_URL}/v2/professional-registration`

export const PROFESSIONAL_TO_ADD = `${import.meta.env.VITE_API_BASE_URL}/professional-to-add`

export const ACCEPT_TERMS = `${USER_REGISTRATION_BASE}/accept-terms`

export const ACCEPT_XRAY_MANUAL = `${USER_REGISTRATION_BASE}/accept-xray-manual`

export const USER_FIREBASE_MANAGER = (professional_id: string) =>
  `${USER_REGISTRATION_BASE}/${professional_id}/firebase`

export const CRUD = (userId: string) => `${USER_REGISTRATION_BASE}/${userId}`

export const PROFESSIONAL = (userId: string) =>
  `${import.meta.env.VITE_API_BASE_URL}/admin/professional-registration/${userId}`

export const IMAGE = (userId: string) =>
  `${import.meta.env.VITE_API_BASE_URL}/professional-image/${userId}`
